import { createContext, useContext, useState } from "react";

const BrandCtx = createContext(null);

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState("ALL"); // ALL | PPD | FRANCHIMOB
  return <BrandCtx.Provider value={{ brand, setBrand }}>{children}</BrandCtx.Provider>;
}

export const useBrand = () => useContext(BrandCtx);
